import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { isDialogOpen } from '../../ui-kit/DialogManager/isDialogOpen.js';
import { useDialogsList } from '../../ui-kit/DialogManager/useDialogsList.js';
import { BurgerMenuDialog } from './BurgerMenuDialog.js';
export const BURGER_MENU_DIALOG_ID = 'burgerMenuDialog';
export const useBurgerMenuDialog = ({ menuRef, centralMenuItem, closeAll, openDialog, locationDialogProps, }) => {
    const dialogs = useDialogsList();
    const isBurgerMenuOpen = isDialogOpen(BURGER_MENU_DIALOG_ID, dialogs);
    const open = () => openDialog(_jsx(BurgerMenuDialog, { locationDialogProps: locationDialogProps, menuRef: menuRef, menuItem: centralMenuItem, closeAll: closeAll }), {
        id: BURGER_MENU_DIALOG_ID,
    });
    const toggle = () => {
        if (isBurgerMenuOpen) {
            closeAll();
        }
        else {
            open();
        }
    };
    return [isBurgerMenuOpen, { toggle }];
};
//# sourceMappingURL=useBurgerMenuDialog.js.map